// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"SectionLRB_TheComp__Kr2cE"};